import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';

export default function WelcomeModal({ open, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;
  const handleStart = () => {
    if (typeof onClose === 'function') onClose();
    navigate('/workout');
  };
  return (
    <div className="welcome-modal-overlay" onClick={onClose}>
      <div className="welcome-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="welcome-modal-title">
        <div className="welcome-modal-header">
          <h3 id="welcome-modal-title">
            Welcome to <span className="welcome-modal-brand">ColeDitioned</span> Coaching
          </h3>
          <div className="welcome-modal-whatsapp">
            <div className="welcome-modal-whatsapp-logo" aria-hidden="true">
              <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="#67C15E"
                  d="M24 4C12.95 4 4 12.95 4 24c0 3.77 1.05 7.29 2.87 10.29L4.47 43.53l9.52-2.34A19.9 19.9 0 0 0 24 44c11.05 0 20-8.95 20-20S35.05 4 24 4z"
                />
                <path
                  fill="#ffffff"
                  d="M33.1 27.95c-.5-.25-3.08-1.52-3.56-1.7-.48-.18-.83-.25-1.18.26-.35.5-1.35 1.7-1.65 2.04-.3.34-.6.38-1.1.13-.5-.25-2.14-.78-4.07-2.5-1.5-1.34-2.52-3-2.82-3.5-.3-.5-.03-.77.22-1.02.22-.22.5-.57.74-.85.25-.3.33-.5.5-.83.16-.33.08-.62-.04-.88-.13-.25-1.17-2.8-1.6-3.84-.43-1.02-.87-.88-1.18-.9h-1c-.33 0-.87.13-1.32.62-.46.5-1.74 1.7-1.74 4.14 0 2.43 1.78 4.8 2.03 5.14.25.33 3.5 5.34 8.47 7.48 1.18.5 2.1.8 2.82 1.03 1.18.37 2.26.32 3.1.2.95-.15 2.9-1.2 3.3-2.36.4-1.16.4-2.16.28-2.36-.1-.2-.45-.32-.95-.58z"
                />
              </svg>
            </div>
            <div className="welcome-modal-whatsapp-copy">
              <p className="welcome-modal-whatsapp-title">Connect with Cole on WhatsApp</p>
              <a
                className="welcome-modal-whatsapp-btn"
                href="https://wa.me/14695045935"
                target="_blank"
                rel="noopener noreferrer"
              >
                Add on WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="welcome-modal-body">
          <p>Nice work finishing your assessment!</p>
          <p>Let's go ahead and generate your workout plan.</p>
          <p>Cole will review your programming once generated for final approval within 24-48hrs.</p>
        </div>
        <div className="welcome-modal-actions">
          <button className="welcome-modal-primary-btn" onClick={handleStart}>Let's get to work</button>
        </div>
      </div>
    </div>
  );
}
